import { render } from "./ProfileUserSvg.vue?vue&type=template&id=0a3eb2b0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__